/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking200,
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking401,
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking500,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentParcelsParcelidOrderTracking.ts";
import { individualPaymentOrderTrackingViewModelSchema } from "../individualPaymentOrderTrackingViewModelSchema.ts";

export const getApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams>;

export const getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelidOrderTracking200Schema =
  z.array(
    z.lazy(() => individualPaymentOrderTrackingViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidOrderTracking200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelidOrderTracking401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidOrderTracking401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelidOrderTracking500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidOrderTracking500>;

export const getApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentParcelsParcelidOrderTracking200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse>;
